export const initialStatusOptions = {
  background: true,
  border: true,
  font: 2,
  bright: 80,
};
